import { useEffect, useState } from 'react';

/**
 * „Új változat érhető el" sáv. (2026-09-30)
 *
 * Frissítés után a böngészőben **addig a régi program fut**, amíg a lapot
 * újra be nem töltik. A telefonra kitett alkalmazás pedig napokig nyitva
 * maradhat a háttérben — a sofőr így hiába kapna javítást, nem érne hozzá.
 *
 * Ezért a program időnként megkérdezi a szervertől, melyik a kitelepített
 * változat, és ha nem az övé, kiír egy sávot. **Magától soha nem tölti
 * újra a lapot** — az félbehagyott beírást vihetne el; a felhasználó
 * koppint rá, amikor épp nem gépel.
 */

/** A most futó program fájlneve — az index.html hivatkozásából. */
function sajatFajl(): string | null {
  const script = document.querySelector<HTMLScriptElement>('script[type="module"][src*="/assets/"]');
  const forras = script?.getAttribute('src') ?? null;
  return forras ? (forras.split('/').pop() ?? null) : null;
}

/** Tizenöt percenként, és minden alkalommal, amikor előveszik a programot. */
const GYAKORISAG = 15 * 60 * 1000;

export function UjValtozat() {
  const [ujVan, setUjVan] = useState(false);

  useEffect(() => {
    const enyem = sajatFajl();
    /* Fejlesztés közben nincs ilyen fájl — ilyenkor nincs mit figyelni. */
    if (!enyem) return;

    let el = true;
    async function megnez() {
      if (!el || document.hidden) return;
      try {
        const v = await fetch('/api/valtozat', { cache: 'no-store' });
        if (!v.ok) return;
        const { fajl } = (await v.json()) as { fajl: string | null };
        if (fajl && fajl !== enyem) setUjVan(true);
      } catch {
        /* nincs hálózat — majd legközelebb */
      }
    }

    void megnez();
    const ora = setInterval(() => void megnez(), GYAKORISAG);
    const elovettek = () => {
      if (!document.hidden) void megnez();
    };
    document.addEventListener('visibilitychange', elovettek);
    window.addEventListener('focus', elovettek);
    return () => {
      el = false;
      clearInterval(ora);
      document.removeEventListener('visibilitychange', elovettek);
      window.removeEventListener('focus', elovettek);
    };
  }, []);

  if (!ujVan) return null;

  return (
    <div className="ujvaltozat" onClick={() => location.reload()} role="button" tabIndex={0}>
      Új változat érhető el — <b>koppints ide a frissítéshez</b>
    </div>
  );
}
